import { RenderFunc } from '../types/RenderFunc';

export const renderApproveApproved: RenderFunc = item => {
  const { newValue, oldValue } = item;

  return {
    renderedOldValue:
      typeof oldValue === 'boolean'
        ? (oldValue && 'Согласовано') || 'Отказано'
        : (typeof oldValue === 'string' && oldValue) || '',
    renderedNewValue:
      typeof newValue === 'boolean'
        ? (newValue && 'Согласовано') || 'Отказано'
        : (typeof newValue === 'string' && newValue) || '',
  };
};
